import { childMixin as child } from './child';
import { rootMixin as root } from './root';
import { propOrDefaultMixin as propOrDefault } from './propOrDefault';
import { safeScopedSlotMixin as safeScopedSlot } from './safeScopedSlot';

export const childMixin = child;
export const rootMixin = root;
export const propOrDefaultMixin = propOrDefault;
export const safeScopedSlotMixin = safeScopedSlot;
